<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <el-row :gutter="10" v-if="global.type == 'manage'">
            <el-col :span="3">
              <h4>选择客户</h4>
            </el-col>
            <el-col :span="12">
              <el-select v-model="customerValue" placeholder="请选择" @change="customerChange">
                <el-option
                  v-for="item in customerData"
                  :key="item.number"
                  :label="item.number + item.client_name"
                  :value="item.client_name">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <!-- <el-divider content-position="left">选择图片</el-divider> -->
          <el-radio-group v-model="imgType" @input="ImgTypeChange">
            <div class="img_type_box">
              <el-radio-button :label="'选择效果图'"></el-radio-button>
              <el-radio-button :label="'选择底图'"></el-radio-button>
            </div>
          </el-radio-group>
          <!-- <div class="">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item, index) in slideData" :key="index">
                <img :src="item.photo_url" alt="" />
                <div class="radio">
                  <el-radio v-model="slideCur" :label="index">{{ effectCur + (index+1) }}</el-radio>
                </div>
              </swiper-slide>
              <div class="swiper-button-next" slot="button-next"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>
          </div> -->
          <div v-if="imgType == '选择效果图'" class="slide_box" v-infinite-scroll="getSlide" infinite-scroll-distance="100" :style="'max-height:'+boxHeight+';'">
            <waterfall v-if="slideData.length > 0" class="slide_main" :col="5" :gutterWidth="20" :data="slideData" :lazyDistance="200">
              <template>
                <div v-for="(item, index) in slideData" :key="'meterial'+index" class="item">
                  <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="" @click="toDetail(index)">
                  <div class="radio" @click="slideClick(index)">
                    <el-radio v-model="slideCur" :label="index">{{ item.space_type + String(index+1) }}</el-radio>
                  </div>
                </div>
              </template>
            </waterfall>
            <div class="" v-if="slideData.length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
          </div>
          <div v-if="imgType == '选择底图'" class="slide_box2">
            <waterfall v-if="slideData.length > 0" class="slide_main" :col="5" :gutterWidth="20" :data="slideData" :lazyDistance="200">
              <template>
                <div v-for="(item, index) in slideData" :key="'meterial'+index" class="item">
                  <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="" @click="toDetail(index)">
                  <div class="radio" @click="slideClick(index)">
                    <el-radio v-model="slideCur" :label="index">{{ item.space_type + String(index+1) }}</el-radio>
                  </div>
                </div>
              </template>
            </waterfall>
            <div class="" v-if="slideData.length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
          </div>
          <div class="choose_img" v-if="steps >= 1">
            <div class="img_title">当前选中的图片</div>
            <div class="img_wrapper">
              <img :src="nowImg + '?x-oss-process=image/resize,w_400'" alt="">
            </div>
          </div>
          <div class="btn_analysis" v-if="steps >= 1">
            <el-button type="success" @click="onAnalysis" :loading="analysisType" style="width:100%;">{{ analysisType == true ? '正在解析' : '立即解析图片' }}</el-button>
          </div>
          <div class="progress" v-if="analysisType == true">
          <!-- <div class="progress"> -->
            <el-progress :percentage="analysisPercent"></el-progress>
          </div>
          <div class="analysis_result" v-if="steps >= 1 && hasAnalyzed" v-html="analysisContent"></div>
          <el-divider v-if="steps >= 1" content-position="left">文案改图</el-divider>
          <div class="" v-if="steps >= 1">
            <div class="ai_para_box">
              <div class="cue_word">
                <div class="item">
                  <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="zh_content"
                    resize="none"
                    @input="contentInput">
                  </el-input>
                  <div class="lexicon">
                    <el-button type="success" size="small" @click="toLexicon" plain>提示词库</el-button>
                  </div>
                  <div class="translate">
                    <el-button type="success" size="small" @click="goLexicon" plain>AI扩写润色</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-divider content-position="left" v-if="steps >= 1">AI大模型</el-divider>
          <div class="" v-if="steps >= 1">
            <el-radio-group v-model="aiCur">
              <div class="ai_box">
                <el-radio v-for="(item,index) in aiData" :key="'ai'+index" :label="item.model_id">{{ item.model_name + '(' + item.price + ')' }}</el-radio>
              </div>
            </el-radio-group>
          </div>
          <div class="btn_save" v-if="steps >= 1">
            <el-button type="success" @click="onSubmit" style="width:100%;">立即生成</el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>
          <div class="effect_box" v-if="resultStatus != 0">
            <div class="complete" v-if="resultStatus == 2">
              <div class="list">
                <div class="item">
                  <img :src="slideData[slideCur].photo_url" alt="">
                  <div class="name">修改前</div>
                </div>
                <div class="item">
                  <img :src="effectData[0].file_url" @click="toEffectDetail" alt="">
                  <div class="name">修改后</div>
                </div>
              </div>
            </div>
            <div class="progress" v-if="resultStatus == 1">
              <el-progress :percentage="percent"></el-progress>
            </div>
          </div>
        </div>
        <el-dialog
          v-if="dialogVisitable == 'detail'"
          :visible.sync="dialogVisit"
          top="15vh"
          :show-close="false"
          :center="true">
          <div class="img" v-if="dialogCur != -1">
            <!-- <img :src="slideData[dialogCur].photo_url" alt=""> -->
             <img :src="detailImg" alt="">
          </div>
        </el-dialog>
        <el-dialog
          v-if="dialogVisitable == 'effectDetail'"
          :visible.sync="dialogVisit"
          width="70%"
          :show-close="true"
          center>
          <!-- <div class="img" v-if="dialogCur[0] != -1">
            <img v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 0" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" alt="">
            <video v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 1" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" alt="" controls></video>
          </div> -->
          
          <div class="detail_box">
            <div class="img" v-if="effectData.length > 0">
              <img :src="effectData[0].file_url" alt="">
            </div>
          </div>
          <el-row :gutter="20" class="tool">
            <el-col v-if="effectData[0].workblank_id == 0" :span="8"><el-button type="success" icon="el-icon-picture" plain @click="toPath('/effectvideo')">图生视频</el-button></el-col>
            <el-col v-if="effectData[0].workblank_id == 0" :span="8"><el-button type="success" :icon="favoriteType == true ? 'el-icon-star-off' : 'el-icon-star-on'" @click="toFavorite" plain>{{ favoriteType == true ? '收藏' : '取消收藏' }}</el-button></el-col>
            <el-col v-if="effectData[0].workblank_id != 0" :span="12"><el-button type="success" icon="el-icon-refresh" @click="toReplace" plain>替换底图</el-button></el-col>
            <el-col :span="effectData[0].workblank_id == 0 ? 8 : 12"><el-button type="success" icon="el-icon-download" plain @click="toDownload">下载</el-button></el-col>
          </el-row>
        </el-dialog>
        <el-dialog
          v-if="dialogVisitable == 'lexicon'"
          :visible.sync="dialogVisit"
          custom-class="lexicon_box"
          top="15vh"
          :show-close="true"
          :center="true"
          :closeDetail="closeDetail">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item v-for="(item, index) in lexiconLabelData" :key="'lexiconLabel'+index" :index="index.toString()">{{ item }}</el-menu-item>
          </el-menu>
          <div class="lexicon_list">
            <el-checkbox-group v-model="lexiconCheckList" v-if="lexiconData[activeIndex].length > 0">
              <el-checkbox v-for="(item, index) in lexiconData[activeIndex]"  :key="'lexicon'+index" :label="item.word"></el-checkbox>
            </el-checkbox-group>
            <div class="" v-if="lexiconData[activeIndex].length <= 0">
              <el-empty :image-size="50" description="暂无数据"></el-empty>
            </div>
          </div>
          <div class="choose_list" v-if="lexiconCheckList.length > 0">
            <el-tag
              v-for="(item, index) in lexiconCheckList"
              :key="'choose' + index"
              :closable="true"
              :disable-transitions="true"
              @close="handleClose(index)"
              type="success">
              {{item}}
            </el-tag>
          </div>
          <el-row :gutter="10">
            <el-col :span="4" :offset="19">
              <el-button type="success" @click="confirmLexicon">确定</el-button>
            </el-col>
          </el-row>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>

import { getUser } from '../../utils/api'
import { apiDownload } from '@/utils/download';

let _ajaxType = 0

export default {
  name: 'AiEdit',
  components: {},
  data() {
    return {
      title: '',
      id: 0,
      customerData: [],
      customerValue: '',
      slideData: [],
      slideCur: 0,
      chooseEffect: '',
      chooseEffectSpace: '',
      uploadImg: '',
      aiData: [],
      aiCur: '',
      zh_content: '',
      en_content: '',
      effectId: "0",
      effectData: [],
      effectDataCur: 0,
      resultStatus: 0,
      percent: 0,
      page: 0,
      pagesize: 100,
      allpage: 0,
      materialItemHeight: 100,
      dialogVisit: false,
      dialogVisible: '',
      dialogCur: -1,
      dialogVisitable: '',
      activeIndex: '0',
      favoriteType: true,
      favoriteId: '',
      steps: 0,
      imgType: '选择效果图',
      nowImg: '',
      analysisContent: '',
      lexiconData: [],
      lexiconLabelData: [],
      lexiconCheckList: [],
      analysisType: false,
      analysisPercent: 0,
      detailImg: '',
      boxHeight: '300px',
      hasAnalyzed: false
    }
  },
  mounted() {
    let _title = 'AI改图'
    if(localStorage.getItem('effect_url')){
      this.chooseEffect = localStorage.getItem('effect_url')
      this.chooseEffectSpace = localStorage.getItem('effect_space')
      localStorage.removeItem('effect_url')
      localStorage.removeItem('effect_space')
      console.log('load', this.chooseEffect, this.chooseEffectSpace)
    }
    if(this.global.type == 'client'){
      _title = this.global.clientName
      this.getSlide()
    }
    this.title = _title
    if(this.global.type == 'manage'){
      this.getCustomer()
    }
    this.getAI()
    this.getLexicon()
    if(this.global.isAndroid == false){
      this.boxHeight = '60vh'
    }
  },
  methods: {
    handleClose(cur) {
      let _lexicon = [...this.lexiconCheckList]
      _lexicon.splice(cur, 1)
      this.lexiconCheckList = _lexicon
    },
    closeDetail(e) {
      this.detailImg = ''
      this.dialogCur = -1
      this.dialogVisit = false
      this.dialogVisitable = ''
      e()
    },
    handleSelect(key, keyPath) {
      console.log('handleSelect', key, keyPath);
      this.activeIndex = key
      console.log(this.activeIndex)
    },
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData() {
      // 
    },
    getSlide() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
        console.log('nowCustomer', nowCustomer)
        let _id = 0
        if(this.global.type == 'client'){
          _id = this.global.clientId
        }
        if(this.global.type == 'manage' && nowCustomer){
          _id = nowCustomer.client_id
        }

        // 如果没有客户ID，不发送请求
        if(!_id || _id === 0){
          _ajaxType = 0
          console.log('没有选择客户，跳过加载')
          return
        }

        let _exclude = this.chooseEffect
        let _url = "/api/?mod=effect&action=result_list"
        let _space_data = {
          page: _page + 1,
          pagesize: this.pagesize,
          client_id: _id,
          exclude: _exclude
        }
        this.axios.post(_url, _space_data).then(json => {
          // 获取
          _ajaxType = 0
          let _data = json.data.data
          console.log("effectData", _data);
          if (json.data.errcode == 0) {
            let _slide = []
            if(_data.page == 1){
              console.log('chooseEffect', this.chooseEffect, this.chooseEffect != '')
              if(this.chooseEffect != ''){
                _slide.push({
                  effect_result_id: -1,
                  photo_url: this.chooseEffect,
                  space_type: this.chooseEffectSpace
                })
              }
              this.materialItemHeight = 0
              // setTimeout(this.getHeight, 500)
            }
            let _slideArray = [..._slide, ...this.slideData]
            console.log('slideArray', _slideArray)
            this.page = _data.page
            this.allpage = _data.allpage
            this.slideData = [..._slideArray, ..._data.result]
            console.log('slideData', this.slideData)
            this.slideCur = 0
            // 自动显示第一张选中的图片
            if(this.slideData.length > 0 && _data.page == 1) {
              this.nowImg = this.slideData[0].photo_url
              this.steps = 1
            }
          }
          console.log(json.data);
        })
      }
    },
    getWorkblank() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage' && nowCustomer){
        _id = nowCustomer.client_id
      }

      // 如果没有客户ID，不发送请求
      if(!_id || _id === 0){
        _ajaxType = 0
        console.log('没有选择客户，跳过加载底图')
        return
      }

      // let _space = this.spaceData[_cur].space_type
      let _url = "/api/?mod=workblank&action=list"
      let _workblank_data = {
        client_id: _id,
      }
      this.axios.post(_url, _workblank_data).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("spaceData", _data);
        if (json.data.errcode == 0) {
          this.slideData = _data.result
        }
        console.log(json.data);
      })
    },
    getLexicon() {
      let _url = "/api/?mod=lexicon"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("lexiconData", _data);
        if (json.data.errcode == 0) {
          let _label = []
          let _lexicon = []
          for(let i=0;i<_data.result.length;i++){
            _label.push(_data.result[i].label)
            _lexicon.push(_data.result[i].lexicon)
          }
          this.lexiconData = _lexicon
          this.lexiconLabelData = _label
          // this.activeIndex = _lexicon[0]

          // this.dialogVisible = 'lexicon'
          // this.dialogVisit = true
        }
        console.log(json.data);
      })
    },
    customerChange(e) {
      console.log('customerChange', e)
      let nowCustomer = this.customerData.find(c => c.client_name === e);
      this.global.clientId = nowCustomer.client_id
      this.global.clientName = nowCustomer.client_name
      this.page = 0
      this.allpage = 0
      this.slideData = []
      this.steps = 0
      this.hasAnalyzed = false
      this.analysisContent = ''
      this.analysisPercent = 0
      if(this.imgType == '选择效果图'){
        this.getSlide()
      }
      if(this.imgType == '选择底图'){
        this.getWorkblank()
      }

    },
    getCustomer() {
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("customerData", _data);
        if (json.data.errcode == 0) {
          this.customerData = _data.result

          // 自动选择客户
          if (this.customerData.length > 0) {
            // 如果有记忆的客户名称，优先选择
            if (this.global.clientName) {
              const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
              if (rememberedClient) {
                this.customerValue = rememberedClient.client_name
              } else {
                // 如果记忆的客户不存在，选择第一个
                this.customerValue = this.customerData[0].client_name
              }
            } else {
              // 没有记忆的客户，选择第一个
              this.customerValue = this.customerData[0].client_name
            }

            // 更新全局状态
            const selectedCustomer = this.customerData.find(c => c.client_name === this.customerValue)
            if (selectedCustomer) {
              this.global.clientId = selectedCustomer.client_id
              this.global.clientName = selectedCustomer.client_name
            }

            // 客户选择完成后再加载图片
            this.getSlide()
          }
        }
        console.log(json.data);
      })
    },
    getAI() {
      let _url = "/api/?mod=ai_model"
      let _aiData = {
        type: 2
      }
      this.axios.post(_url, _aiData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("aiData", _data);
        if (json.data.errcode == 0) {
          this.aiCur = _data.result[0].model_id
          this.aiData = _data.result
        }
        console.log(json.data);
      })
    },
    getHeight() {
      let _materialItem = this.$refs.materialItem[0]
      console.log('height', _materialItem.offsetHeight)
      let _row = this.slideData.length > 5 ? 2 : 1
      this.materialItemHeight = _materialItem.offsetHeight * _row + 15
    },
    spaceChange(e) {
      // console.log(e)
      this.getWorkblank()
    },
    onSubmit() {
      console.log('submit!');
      if(_ajaxType == 1) return
      // if(this.resultStatus != 0) return
      let _this = this
      _ajaxType = 1
      let _url = "/api/?mod=effect&action=ai_edit"
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }
      let _prompt = this.zh_content
      let nowAi = this.aiData.find(c => c.model_id === this.aiCur);
      let _saveData = {
        client_id: _id,
        photo_url: this.slideData[this.slideCur].photo_url,
        space_type: this.slideData[this.slideCur].space_type || 'AI改图',
        model_id: this.aiCur,
        description: this.zh_content
      }
      if(this.imgType == '选择底图'){
        _saveData['workblank_id'] = this.slideData[this.slideCur].workblank_id
      }
      console.log(_saveData)
      this.steps = 3
      if(nowAi.language == 'en'){
        this.toTranslate(_saveData)
      }
      if(nowAi.language == 'cn'){
        this.axios.post(_url, _saveData).then(json => {
          let _data = json.data.data
          console.log("saveData", _data);
          if (json.data.errcode == 0) {
            this.effectId = _data.effect_id
            this.resultStatus = 1
            this.percent = 0
            this.getEffect()
            this.axios.post('/api/?mod=user').then(json => {
              if(json.data.errcode == 0){
                _this.global.money = json.data.data.user.money
              }
            })
            this.$message({
              message: '提交成功，正在生成中',
              type: 'success',
              offset: 300,
              duration: 1000,
              onClose: function() {
                let scrollBox = document.querySelector('.main')
                scrollBox.scrollTo({
                  top: 10000,
                  behavior: 'smooth' // 平滑滚动
                });
              }
            });
          } else {
            _ajaxType = 0
            this.$message({
              message: json.data.error || '提交失败',
              type: 'error',
              offset: 300
            });
          }
          console.log(json.data);
        }).catch(() => {
          _ajaxType = 0
          this.$message({
            message: '网络错误，请重试',
            type: 'error',
            offset: 300
          });
        })
      }
    },
    getEffect() {
      let _id = this.effectId
      let _url = "/api/?mod=effect&action=result"
      let _effectData = {
        effect_id: _id
      }
      this.axios.post(_url, _effectData).then(json => {
        // 获取
        // _ajaxType = 0
        let _data = json.data.data
        console.log("effectData", _data);
        if (json.data.errcode == 0) {
          let _percent = this.percent
          if(_percent < 95){
            _percent = _percent + 5
          }
          if(_percent >= 95){
            _percent = 99
          }
          this.percent = _percent
          if(_data.status == 0){
            setTimeout(this.getEffect, 5000)
            return
          }
          if(_data.status == 1){
            _ajaxType = 0
            this.resultStatus = 2
            this.effectData = _data.result
            this.steps = 4
            setTimeout(()=>{
              let scrollBox = document.querySelector('.main')
              scrollBox.scrollTo({
                top: 10000,
                behavior: 'smooth' // 平滑滚动
              });
            },300)
          }
        }
        console.log(json.data);
      })
    },
    handleChange(value) {
      // this.selectedOptions = value;
      console.log(value)
      console.log(this.form)
    },
    toDetail(cur) {
      this.detailImg = this.slideData[cur].photo_url
      this.dialogVisitable = 'detail'
      this.dialogCur = cur
      this.dialogVisit = true
    },
    toEffectDetail() {
      this.dialogVisitable = 'effectDetail'
      this.dialogVisit = true
    },
    slideClick(cur) {
      this.slideCur = cur
      this.nowImg = this.slideData[cur].photo_url
      this.steps = 2
      this.hasAnalyzed = false
      this.analysisContent = ''
    },
    materialClick(cur) {
      this.materialCur = cur
    },
    uploadImage(image) {
      console.log("1", image);
      if(_ajaxType == 1) return
      _ajaxType = 1
      return new Promise((resolve, reject) => {
        // console.log('2',image.file)
        const isImage = image.file.type.startsWith('image/');
        if (!isImage) {
          this.uploadError = '只能上传图片文件';
          _ajaxType = 0
          reject(new Error('只能上传图片文件'));
          return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('upload',e)
          const base64Data = e.target.result;
          this.toUpload(base64Data);
          resolve(false); // 阻止默认上传行为
        };
        reader.onerror = (error) => {
          console.error('读取文件失败:', error);
          this.uploadError = '读取文件失败，请重试';
          reject(error);
        };
        reader.readAsDataURL(image.file);
      });
    },
    toUpload(base64Data) {
      let _url = "/api/?mod=upload"
      let _uploadData = {
        photo: base64Data
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.uploadImg = _data.photo_url
          this.$message({
            message: '上传成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toTranslate(saveData) {
      let _url = "/api/?mod=translate"
      // let _zh = this.zh_content
      let _uploadData = {
        description: saveData['description']
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          // this.en_content = _data.description_en
          saveData['description'] = _data.description_en
          let _url = "/api/?mod=effect&action=ai_edit"
          this.axios.post(_url, saveData).then(json => {
            let _data = json.data.data
            console.log("saveData", _data);
            if (json.data.errcode == 0) {
              this.effectId = _data.effect_id
              this.resultStatus = 1
              this.getEffect()
              // getUser().then(res => {
              //   console.log('user', res)
              //   if(res.errcode == 0){
              //     this.global.money = res.data.user.money
              //   }
              // })
              this.axios.post('/api/?mod=user').then(json => {
                if(json.data.errcode == 0){
                  _this.global.money = json.data.data.user.money
                }
              })
              this.$message({
                message: '提交成功，正在生成中',
                type: 'success',
                offset: 300,
                duration: 1000,
                onClose: function() {
                  let scrollBox = document.querySelector('.main')
                  scrollBox.scrollTo({
                    top: 10000,
                    behavior: 'smooth' // 平滑滚动
                  });
                }
              });
            }
            console.log(json.data);
          })
        }
        console.log(json.data);
      })
    },
    toDownload(){
      const link = document.createElement('a')
      let _type = this.effectData[0].file_type // 替换为你的图片 URL
      // link.download = 'sample.jpg' // 指定下载的文件名
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      let _href = ''
      if(_type == 0){
        let _img = this.effectData[0].file_url
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = this.effectData[0].file_url
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      apiDownload(
        _href
      )
    },
    toPath(path) {
      let _slide = this.slideData
      let _photo = this.effectData[0].file_url
      localStorage.setItem('effect_url', _photo)
      localStorage.setItem('effect_space', _slide[0].space_type)
      this.$router.push({ path: path })
    },
    toFavorite() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect_favorite&action=add"
      let _type = this.favoriteType
      let _id = this.effectData[this.effectDataCur].effect_result_id
      let _favoriteData = {
        effect_result_id: _id
      }
      if(_type == false){
        _url = "/api/?mod=effect_favorite&action=cancel"
        _id = this.favoriteId
        _favoriteData = {
          effect_favorite_id: _id
        }
      }
      console.log(_favoriteData)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          this.favoriteType = !_type
          let _content = '取消成功'
          if(!_type == false){
            _content = '收藏成功'
            this.favoriteId = _data.effect_favorite_id
          }
          this.$message({
            message: _content,
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    onAnalysis() {
      console.log('submit!');
      if(_ajaxType == 1) return
      // if(this.resultStatus != 0) return
      _ajaxType = 1
      this.resultStatus = 0
      this.analysisType = true
      let _url = "/api/?mod=translate&action=image"
      let _nowImg = this.slideData[this.slideCur].photo_url
      let _analysisData = {
        photo_url: _nowImg,
      }
      console.log(_analysisData)
      setTimeout(()=>{
        let scrollBox = document.querySelector('.main')
        scrollBox.scrollTo({
          top: 10000,
          behavior: 'smooth' // 平滑滚动
        });
        this.setPercent()
      }, 500)
      this.axios.post(_url, _analysisData).then(json => {
        // 获取
        _ajaxType = 0
        this.analysisType = false
        let _data = json.data.data
        console.log("analysisData", _data);
        if (json.data.errcode == 0) {
          this.nowImg = _nowImg
          this.steps = 1
          this.analysisContent = _data.content
          this.hasAnalyzed = true
        }
        console.log(json.data);
      })
    },
    setPercent() {
      if(this.analysisType == false){
        return
      }
      if(this.analysisPercent >= 95){
        this.analysisPercent = 99
        return
      }
      console.log('setPercent', this.analysisPercent)
      this.analysisPercent = this.analysisPercent + 5
      setTimeout(()=>{
        this.setPercent()
      }, 800)
    },
    contentInput(e) {
      // console.log('contentInput', e)
      if(this.steps <= 1){
        this.steps = 2
      }
    },
    confirmLexicon() {
      let _content = this.lexiconCheckList
      console.log('content', _content)
      _content = _content.join('，')
      this.zh_content = _content
      this.dialogVisitable = ''
      this.dialogVisit = false
      this.lexiconCheckList = []
      this.steps = 2
    },
    toLexicon() {
      this.dialogVisit = true
      this.dialogVisitable = 'lexicon'
    },
    goLexicon() {
      console.log('goLexicon', this.zh_content)
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=translate&action=refine"
      let _content = this.zh_content
      // _content = _content.join(',')
      let _uploadData = {
        description: _content,
        language: 'cn'
      }
      console.log(_uploadData)
      this.axios.post(_url, _uploadData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("uploadData", _data);
        if (json.data.errcode == 0) {
          this.zh_content = _data.description.replace('\n\n', '')
          // this.dialogCur = -1
          // this.dialogVisible = ''
          // this.dialogVisit = false
        }
        console.log(json.data);
      })
    },
    ImgTypeChange(e) {
      // console.log('ImgTypeChange', e)
      this.page = 0
      this.allpage = 0
      this.slideData = []
      this.steps = 0
      this.hasAnalyzed = false
      this.analysisContent = ''
      this.analysisPercent = 0
      if(e == '选择效果图'){
        this.getSlide()
        return
      }
      this.getWorkblank()
    },
    toReplace() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=workblank&action=save"
      let _content = this.zh_content
      let nowCustomer = this.customerData.find(c => c.client_name === this.customerValue);
      console.log('nowCustomer', nowCustomer)
      let _id = 0
      if(this.global.type == 'client'){
        _id = this.global.clientId
      }
      if(this.global.type == 'manage'){
        _id = nowCustomer.client_id
      }
      // _content = _content.join(',')
      let _replaceData = {
        client_id: _id,
        photo_url: this.effectData[0].file_url,
        workblank_id: this.effectData[0].workblank_id
      }
      console.log(_replaceData)
      this.axios.post(_url, _replaceData).then(json => {
        _ajaxType = 0
        let _data = json.data.data
        console.log("repplace_workblank", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '替换成功',
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
          // this.zh_content = _data.description.replace('\n\n', '')
          // this.dialogCur = -1
          // this.dialogVisible = ''
          // this.dialogVisit = false
        }
        console.log(json.data);
      })
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 2001;
}
.main {
  position: relative;
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    h4 {
      // margin-bottom: 8px;
      // padding-left: 12px;
      background: #fff;
      color: rgb(16, 16, 16);
      font-size: 20px;
      font-weight: 400;
      line-height: 2em;
    }
    .el-input__inner {
      width: auto;
    }
    .form {
      margin-top: 20px;
    }
    .ai_box {
      font-size: 0;
      .el-radio {
        margin: 0 15px 10px 0;
      }
    }
    .img_type_box {
      margin: 20px 0;
    }
    // .space_box,
    // .style_box,
    // .ai_box {
    //   display: grid;
    //   grid-auto-flow: column;
    //   grid-auto-columns: min-content;
    //   // grid-template-columns: repeat(16, 1fr);
    //   gap: 10px;
    //   padding: 10px 0 0;
    //   .el-radio {
    //     margin-right: 0;
    //   }
    // }
    .ai_para_box {
      margin-top: 20px;
      .cue_word {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 10px;
        margin-bottom: 10px;
      }
      .item {
        position: relative;
        .lexicon {
          position: absolute;
          right: 0;
          bottom: 0;
        }
        .translate {
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .slider {
        // margin-top: 20px;
      }
    }
    .upload-demo {
      width: 100%;
      .el-button {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
      }
      img {
        width: 100%;
        aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
        object-fit: cover;
      }
    }
    .slide_box,
    .slide_box2 {
      // display: grid;
      // grid-template-columns: repeat(5, 1fr);
      // padding-inline-start: 0;
      // gap: 20px;
      min-height: 100px;
      max-height: 300px;
      overflow: auto;
      // margin-top: 10px;
      .slide_main {
        // column-count: 5; /* 设置列数 */
        // column-gap: 20px; /* 设置列间距 */
        .item {
          position: relative;
          // break-inside: avoid-column; /* 防止内容在列中断开 */
          margin-bottom: 20px; /* 底部间距 */
          // flex: 0 0 calc(30%);
          background: #fff;
          box-sizing: border-box;
          font-size: 0;
          img {
            width: 100%;
            // aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
            // object-fit: cover;
          }
          .radio {
            margin-top: 8px;
            padding-right: 10%;
            box-sizing: border-box;
            font-size: 0;
            text-align: center;
          }
        }
      }
    }
    .material_type {
      margin-top: 30px;
    }
    .material_box {
      display: grid;
      // flex-wrap: wrap;
      // justify-content: space-between;
      grid-template-columns: repeat(10, 1fr);
      padding-inline-start: 0;
      gap: 10px;
      // margin-top: 10px;
      .item {
        position: relative;
        // flex: 0 0 calc(30%);
        background: #fff;
        box-sizing: border-box;
        img {
          width: 100%;
          aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
          object-fit: cover;
        }
        .radio {
          margin-top: 8px;
          padding-right: 10%;
          box-sizing: border-box;
          font-size: 0;
          text-align: center;
        }
      }
    }
    .btn_analysis {
      width: 30vw;
      margin: 30px 0;
    }
    .choose_img {
      margin-top: 30px;
      padding: 20px;
      background: #f9f9f9;
      border: 2px solid #67c23a;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(103, 194, 58, 0.1);
      .img_title {
        margin-bottom: 15px;
        font-size: 18px;
        font-weight: 600;
        color: #67c23a;
        text-align: center;
      }
      .img_wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        background: #fff;
        border-radius: 8px;
        img {
          max-width: 100%;
          max-height: 400px;
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          object-fit: contain;
        }
      }
    }
    .analysis_result {
      margin-top: 10px;
      padding: 20px;
      border: 2px solid #ddd;
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .effect_box {
      margin-top: 30px;
      .complete {
        .cur {
          height: 200px;
          text-align: center;
          img {
            height: 100%;
          }
        }
        .list {
          margin-top: 10px;
          display: grid;
          // flex-wrap: wrap;
          // justify-content: space-between;
          grid-template-columns: repeat(2, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .item {
            padding: 10px;
            background: #fff;
            border: 1px dashed rgb(187, 187, 187);
            border-radius: 5px;
            box-sizing: border-box;
            img {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
            .name {
              font-size: 18px;
              text-align: center;
              line-height: 30px;
            }
          }
        }
        .tools {
          margin-top: 10px;
          display: grid;
          // flex-wrap: wrap;
          // justify-content: space-between;
          grid-template-columns: repeat(5, 1fr);
          padding-inline-start: 0;
          gap: 10px;
          .el-button {
            width: 100%;
          }
        }
      }
    }
  }
  .progress {
    padding: 150px 0;
  }
  .detail_box {
    display: block;
    // flex-direction: column;
    padding: 30px;
    background-color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .img {
      font-size: 0;
      text-align: center;
      img {
        max-width: 100%;
        max-height: 60vh;
        border-radius: 10px;
      }
      video {
        max-width: 100%;
        max-height: 60vh;
      }
    }
    .list {
      display: grid;
      grid-template-rows: 50px;       /* 首行高度80px */
      // grid-auto-rows: minmax(60px, 1fr);
      // grid-auto-rows: minmax(calc(100%/7), 1fr);
      gap: 10px;
      height: 100%;
      padding: 20px;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 10px;
      .item {
        height: 100%;
        border-bottom: 1px solid #eee;
        .label {
          display: flex;
          width: 30%;
          height: 100%;
          float: left;
          font-size: 18px;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .content {
          display: flex;
          width: 70%;
          height: 100%;
          float: right;
          font-size: 18px;
          justify-items: right;
          align-items: center;
        }
        &.title {
          font-size: 24px;
          font-weight: 700;
        }
        &:last-child {
          border: 0;
        }
      }
    }
  }
  .tool {
    margin: 0 !important;
    padding: 0 20px 30px;
    background-color: #fff;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .el-button {
      width: 100%;
    }
  }
  .lexicon_list {
    // background: #fff;
    width: 60vw;
    min-height: 200px;
    margin-top: 20px;
    font-size: 0;
    .el-checkbox {
      margin: 0 30px 20px 0;
    }
  }
  .choose_list {
    margin-top: 30px;
    font-size: 0;
    .label {
      font-size: 14px;
      line-height: 30px;
    }
    .el-tag {
      margin: 0 0 10px 10px;
    }
    .el-button {
      margin: 0 0 10px 10px;
    }
  }
}
.el-dialog {
  .img {
    font-size: 0;
    text-align: center;
    img {
      // max-width: 100%;
      // max-height: 70vh;
      // object-fit: contain;
      max-width: 80vw;
      max-height: 70vh;
      object-fit: contain;
    }
  }
}
.el-divider--horizontal {
  margin: 30px 0;
}
.el-divider__text {
  font-size: 20px;
  font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/views/Effect/AiEdit.vue